import * as React from "react";
const SvgCloseIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "11px", height: "11px", viewBox: "0 0 11 11", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1,1 L10,10 M10,1 L1,10", stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.5 }));
export { SvgCloseIcon as ReactComponent };
